import { PermanentDetailViewModel, PermanentListItemViewModel } from "@payping/api";
import { LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";

export const PERMALINKS_LOADED = "PERMALINKS_LOADED";
export const SET_PERMALINK_DETAILS = "SET_PERMALINK_DETAILS";
export const PERMALINK_REMOVED = "PERMALINK_REMOVED";

export interface PermaLinkState {
  list: PermanentListItemViewModel[];
  totalCount: number;
  details?: PermanentDetailViewModel;
}

export interface PermaLinksLoadedAction {
  type: typeof PERMALINKS_LOADED;
  payload: { list: PermanentListItemViewModel[]; totalCount: number };
}

export interface SetPermaLinkDetailsAction {
  type: typeof SET_PERMALINK_DETAILS;
  payload: { details: PermanentDetailViewModel };
}

export interface PermaLinkRemovedAction {
  type: typeof PERMALINK_REMOVED;
  payload: { code: string };
}

export type PermalinkActionTypes =
  | PermaLinksLoadedAction
  | SetPermaLinkDetailsAction
  | PermaLinkRemovedAction
  | ClearListAction
  | LoggedOutAction;

const initialState: PermaLinkState = {
  details: undefined,
  list: [],
  totalCount: 0,
};

export default function permalinks(state = initialState, action: PermalinkActionTypes): PermaLinkState {
  if (action.type === PERMALINKS_LOADED) {
    const { list, totalCount } = action.payload;
    return {
      ...state,
      list,
      totalCount,
    };
  }

  if (action.type === SET_PERMALINK_DETAILS) {
    const { details } = action.payload;
    return {
      ...state,
      details,
    };
  }

  if (action.type === PERMALINK_REMOVED) {
    const { code } = action.payload;
    const list = state.list.filter((item) => item.code !== code);
    const details = state.details && state.details.code === code ? initialState.details : state.details;
    const totalCount = state.totalCount - 1;

    return {
      ...state,
      details,
      list,
      totalCount,
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
